<template>
    <div class="title">
        <div class="left">
            <h4>
                {{ $route.meta.title }}
            </h4>
            <svg class="svg-icon crumbs" aria-hidden="true" v-if="showCrumbs">
                <use :xlink:href="'#icon-crumbs'"></use>
            </svg>
            <p v-if="$route.meta.type">
                <span>·</span>
                {{ $route.meta.type }}
            </p>
            <p v-if="$route.meta.subtitle">
                <span>·</span>
                {{ $route.meta.subtitle }}
            </p>
        </div>
        <slot name="rightTool" class="right"></slot>
    </div>
</template>

<script>
export default {
    name: 'NavTitle',
    computed: {
        showCrumbs() {
            return !(
                _.isEmpty(this.$route.meta.type) &&
                _.isEmpty(this.$route.meta.subtitle)
            );
        }
    }
};
</script>

<style scoped lang="scss">
.title {
    display: flex;
    margin: 0 auto;
    padding: 16px 0;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    .left {
        display: flex;
    }
    h4 {
        margin: 0;
        margin-right: 16px;
        font-size: 14px;
        letter-spacing: -0.33px;
        color: rgba(0, 0, 0, 0.65);
    }
    .crumbs {
        font-size: 16px;
        margin-right: 7px;
        color: #75808b;
    }
    p {
        margin: 0;
        font-size: 12px;
        font-weight: 500;
        letter-spacing: -0.33px;
        color: #75808b;
        margin-right: 6px;
    }
}
</style>
